import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Claim } from '../../fragments';

const CLAIM_QUERY = gql`
  query CLAIM_QUERY($id: ID!) {
    claim(id: $id) {
      ...Claim,
      airlineAgreementDate,
      airlineAgreementAmount,
      courtName,
      courtHearingAt,
      lawyer {
        id
        name
        surname
      }
    }
  }
  ${Claim.fragment}
`;

const withClaimQuery = graphql(CLAIM_QUERY, {
  options: ({ task }) => ({
    variables: {
      id: task && task.claimId
    }
  }),
  props: ({ data: { claim, loading, error } }) => ({
    error,
    loading,
    claim
  })
});

export default withClaimQuery;



// WEBPACK FOOTER //
// ./src/component/tasks/withClaimQuery.js